import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class VenuesService {
  constructor(private http: HttpClient) {}

  addCompany = (venueId, payload) =>
    this.http.put(
      `/rest-api/admin-panel/api/v1/admin/venues/${venueId}/add_company`,
      payload
    );

  skipImports = (venueId) =>
    this.http.put(
      `/rest-api/admin-panel/api/v1/admin/venues/${venueId}/skip_import`,
      {}
    );

  includeInEventsImports = (venueId) =>
    this.http.put(
      `/rest-api/admin-panel/api/v1/admin/venues/${venueId}/include_in_import`,
      {}
    );

  deleteVenue = (venueId) =>
    this.http.delete(
      `/rest-api/admin-panel/api/v1/admin/venues/${venueId}`,
      {}
    );

  searchVenues = (params) => {
    return this.http.get(`rest-api/v1/venues/search`, {params});
  };

  getVenue = (venueId) => {
    return this.http.get<Venue>(`rest-api/v1/companies/venues/${venueId}`);
  };

  putVenue = (venueId, body) => {
    return this.http.put<Venue>(`rest-api/v1/companies/venues/${venueId}`, body);
  };

  getVenueDetails = (venueId) => {
    return this.http.get<VenueDetails>(`rest-api/v1/companies/venues/${venueId}/details`);
  };

  putVenueDetails = (venueId, body) => {
    return this.http.put<VenueDetails>(`rest-api/v1/companies/venues/${venueId}/details`, body);
  };

  putVenuePhoto = (venueId, body) => {
    return this.http.put<VenueDetails>(`rest-api/v1/companies/venues/${venueId}/profile_photo`, body);
  };

  putVenueProfilePhoto = (venueId, body) => {
    return this.http.put<VenueDetails>(`rest-api/v1/companies/venues/${venueId}/profile_photo`, body);
  };

  putVenueCoverPhoto = (venueId, body) => {
    return this.http.put<VenueDetails>(`rest-api/v1/companies/venues/${venueId}/cover_photo`, body);
  };

  uploadVenuePhoto = (venueId, body) => {
    return this.http.post<any>(`rest-api/v1/companies/venues/${venueId}/albums/upload`, body);
  };

  getVenueAlbums = (venueId) => {
    return this.http.get<any>(`rest-api/v1/companies/venues/${venueId}/albums`);
  };

  getVenueAlbumById = (albumId) => {
    return this.http.get<any>(`rest-api/v1/companies/venues/albums/${albumId}`);
  };

  deleteAlbum = (albumId) =>
    this.http.delete(
      `/rest-api/v1/companies/venues/albums/${albumId}`,
      {}
    );

  publishAlbum = (albumId) => {
    return this.http.put<any>(`rest-api/v1/companies/venues/albums/${albumId}/publish`, {});
  };

  getVenueAlbumPhotos = albumId => {
    return this.http.get<any>(`rest-api/v1/companies/venues/albums/${albumId}/photos`);
  };

  getFormOptions = () => {
    return this.http.get(`rest-api/v1/variables/venue/form-options`);
  };

  getDetailsFields = (category: string) => {
    return this.http.get(`/rest-api/v1/variables/form-fields`, { params: { category } });
  }
}
export interface Venue {
  id: number;
  name: string;
  category: null;
  info: null;
  translated_descriptions: Record<string, string>;
  supported_languages: string[];
  address: Address;
  opening_hours: OpeningHours;
  phone_number: null;
  status: string;
  website: null;
  is_verified: boolean;
  profile_photo: string;
  cover_photo: string;
  company: number;
  facebook_page: null;
  profile_photo_preview?: string;
  cover_photo_preview?: string;
}

export interface Address {
  id_address: number;
  zip_code: string;
  street: string;
  city: string;
  country: string;
  latitude: number;
  longitude: number;
  is_dummy: boolean;
}

export interface OpeningHours {}

export interface VenueOptions {
  countries: Country[];
  venue_statuses: Country[];
  venue_categories: Country[];
}

export interface Country {
  name: string;
  value: string;
}
export interface VenueDetails {
  variable_instagram: string;
  variable_facebook_page: string;
}
